
import React from "react";
import { WeeklySummary } from './summary/WeeklySummary';
import { AnnualSummary } from './summary/AnnualSummary';
import { ContributionBreakdownSummary } from './summary/ContributionBreakdownSummary';
import { NursingHomeCostSummary } from './summary/NursingHomeCostSummary';
import { ContributionCapExplanation } from './summary/ContributionCapExplanation';

interface ContributionSummaryProps {
  results: any;
  formData: any;
}

export function ContributionSummary({ results, formData }: ContributionSummaryProps) {
  const hasNursingHomeCost = formData.nursingHomeCost > 0;
  const isUsingLoan = formData.useLoan;
  
  // Calculate contribution with loan applied if using loan
  const weeklyPaymentWithLoan = results.weeklyContribution - (isUsingLoan ? results.deferredAmount : 0);
  
  // Ensure payment is capped at nursing home cost if applicable
  const actualWeeklyPayment = hasNursingHomeCost 
    ? Math.min(weeklyPaymentWithLoan, formData.nursingHomeCost) 
    : weeklyPaymentWithLoan;
    
  const actualAnnualPayment = actualWeeklyPayment * 52;
  
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <WeeklySummary
          actualWeeklyPayment={actualWeeklyPayment}
          weeklyPaymentWithLoan={weeklyPaymentWithLoan}
          nursingHomeCost={formData.nursingHomeCost}
          deferredAmount={results.deferredAmount}
          isUsingLoan={isUsingLoan}
          hasNursingHomeCost={hasNursingHomeCost}
        />
        <AnnualSummary actualAnnualPayment={actualAnnualPayment} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <ContributionBreakdownSummary
          incomeContributionWeekly={results.incomeContribution.weekly}
          assetContributionWeekly={results.assetContribution.weekly}
          deferredAmount={results.deferredAmount}
          isUsingLoan={isUsingLoan}
        />
        
        {hasNursingHomeCost && (
          <NursingHomeCostSummary
            nursingHomeCost={formData.nursingHomeCost}
            actualWeeklyPayment={actualWeeklyPayment}
            weeklyPaymentWithLoan={weeklyPaymentWithLoan}
          />
        )}
      </div>

      {hasNursingHomeCost && weeklyPaymentWithLoan > formData.nursingHomeCost && (
        <ContributionCapExplanation
          weeklyPaymentWithLoan={weeklyPaymentWithLoan}
          nursingHomeCost={formData.nursingHomeCost}
          actualWeeklyPayment={actualWeeklyPayment}
        />
      )}
    </div>
  );
}
